import _classCallCheck from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/darrenkey/Documents/ai-lofi-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { getContext } from "../Global";
import { TimeClass } from "./Time";
/**
 * TransportTime is a the time along the Transport's
 * timeline. It is similar to Tone.Time, but instead of evaluating
 * against the AudioContext's clock, it is evaluated against
 * the Transport's position. See [TransportTime wiki](https://github.com/Tonejs/Tone.js/wiki/TransportTime).
 * @category Unit
 */
export var TransportTimeClass = /*#__PURE__*/function (_TimeClass) {
  _inherits(TransportTimeClass, _TimeClass);
  function TransportTimeClass() {
    var _this;
    _classCallCheck(this, TransportTimeClass);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(TransportTimeClass).apply(this, arguments));
    _this.name = "TransportTime";
    return _this;
  }
  /**
   * Return the current time in whichever context is relevant
   */
  _createClass(TransportTimeClass, [{
    key: "_now",
    value: function _now() {
      return this.context.transport.seconds;
    }
  }]);
  return TransportTimeClass;
}(TimeClass);
/**
 * TransportTime is a the time along the Transport's
 * timeline. It is similar to [[Time]], but instead of evaluating
 * against the AudioContext's clock, it is evaluated against
 * the Transport's position. See [TransportTime wiki](https://github.com/Tonejs/Tone.js/wiki/TransportTime).
 * @category Unit
 */
export function TransportTime(value, units) {
  return new TransportTimeClass(getContext(), value, units);
}